interface LegalHeroSectionProps {
  pageName: string;
  title: string;
  dateDescription: string;
  description: string;
  warningText?: string;
}

export default function LegalHeroSection({ pageName, title, dateDescription, description, warningText }: LegalHeroSectionProps) {
  return (
    <section className="w-full">
      <div className="container mx-auto relative w-full py-8 md:py-12 my-8 md:my-12">
        <div className="flex flex-col items-center text-center">
          <div className="mb-8">
            <h2 className="text-sm font-bold uppercase tracking-wider text-slate-900 mb-2">{pageName}</h2>
            <h1 className="text-3xl md:text-4xl font-bold text-fb-primary mb-4">
              {title}
            </h1>
            <p className="mb-2 font-semibold text-slate-900">{dateDescription}</p>
            {warningText && (
              <p className="mb-2 font-semibold text-orange-700">{warningText}</p>
            )}
            <p className="mb-4 font-thin text-slate-900">{description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}